// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyBdqo4xU7zABlAWhlJed5ks6z2hXdgItUA",
    authDomain: "rastromais-7kbpxd.firebaseapp.com",
    projectId: "rastromais-7kbpxd",
    storageBucket: "rastromais-7kbpxd.firebasestorage.app",
    messagingSenderId: "725304661850",
    appId: "1:725304661850:web:8c42322e3052f31f2fc563"
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators if in development mode
if (process.env.NODE_ENV === 'development') {
    // Use a flag to prevent multiple connections
    if (!window.firebaseEmulatorsConnected) {
        try {
            connectAuthEmulator(auth, 'http://localhost:9099');
            connectFirestoreEmulator(db, 'localhost', 8080);
            connectStorageEmulator(storage, 'localhost', 9199);
            connectFunctionsEmulator(functions, 'localhost', 5001);
            
            // Set flag to prevent reconnection
            window.firebaseEmulatorsConnected = true;
            console.log('🔥 Firebase emulators connected for development');
        } catch (error) {
            // Emulators might already be connected, which is fine
            console.log('🔥 Firebase emulators already connected or connection failed:', error.message);
        }
    }
}
